import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import GuestMeetingView from './GuestMeetingView';
import GuestJoinView from './GuestJoinView';
import GuestHungUpView from './GuestHungUpView';
import {
	peersLengthSelector
} from '../../Selectors';
import * as meActions from '../../../actions/meActions';
import * as roomActions from '../../../actions/roomActions';
import { firestore } from '../../../lib/firebase';

// Const
import { ROOM_ONLINE, ROOM_CALLING } from '../../../const';

const styles = () =>
	({
		root :
		{
			width                        : 'fit-content',
			minWidth                     : '750px',
			height                       : '87%',
			maxHeight                    : '1080px',
			maxWidth                     : '96vw',
			position                     : 'relative',
			display                      : 'flex',
			flexDirection                : 'column',
			overflow                     : 'auto',
			borderRadius                 : '10px',
			backgroundColor              : '#e5e5e2',
			padding                      : '2% 0.5%',
			alignItems                   : 'center',
			justifyContent               : 'center',
			zIndex                       : 1,
			minHeight                    : '600px',
			'@media (max-height: 600px)' : {
				borderRadius : '0px'
			}
		},
		rootConnected :
		{
			width           : 'fit-content',
			minWidth        : '800px',
			height          : '84%',
			maxHeight       : '1080px',
			maxWidth        : '1000px',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			overflow        : 'auto',
			borderRadius    : '10px',
			backgroundColor : '#e5e5e2',
			padding         : '2% 0.75%',
			alignItems      : 'center',
			justifyContent  : 'center',
			zIndex          : 1,
			minHeight       : '600px'

		},
		rootM :
		{
			width           : '98%',
			height          : '100%',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			overflow        : 'auto',
			borderRadius    : '10px',
			backgroundColor : '#e5e5e2',
			padding         : '2%',
			alignItems      : 'center',
			justifyContent  : 'flex-start',
			marginBottom    : '2%',
			zIndex          : 1
		},
		rootML :
		{
			width           : '100%',
			height          : '98%',
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			overflow        : 'auto',
			borderRadius    : '10px',
			backgroundColor : '#e5e5e2',
			padding         : '1%',
			margin          : '0 2%',
			alignItems      : 'center',
			justifyContent  : 'flex-start',
			zIndex          : 1
		}
	});

const GuestHome = ({
	room,
	roomClient,
	classes,
	setRooms,
	setSettings,
	isMobile,
	useMobileView,
	setOrientation,
	orientation,
	peersLength
}) =>
{
	const [ fetchRoomsComplete, setFetchRoomsComplete ] = useState(false);

	const guestHomeRef = useRef();

	const fetchRooms = useCallback(() =>
	{
		const parts = window.location.hostname.split('.');
		const subdomain = parts.shift();

		firestore.collection('rooms')
			.where('subdomain', '==', subdomain)
			.onSnapshot((querySnapshot) =>
			{
				const currentRooms = [];

				querySnapshot.forEach((doc) =>
				{
					const item = doc.data();

					if (item.status === ROOM_ONLINE || item.status === ROOM_CALLING)
					{
						currentRooms.push({
							id : doc.id,
							...item
						});
					}
				});

				currentRooms.sort((a, b) =>
				{
					if (a.index < b.index) { return -1; }
					if (a.index > b.index) { return 1; }

					return 0;
				});

				setRooms(currentRooms);
				setFetchRoomsComplete(true);
			},
			(error) =>
			{
				setFetchRoomsComplete(true);
			});

	}, [ setRooms ]);

	const fetchSettings = useCallback(() =>
	{
		const parts = window.location.hostname.split('.');
		const subdomain = parts.shift();

		firestore.collection('settings').where('subdomain', '==', subdomain)
			.onSnapshot((querySnapshot) =>
			{
				querySnapshot.forEach((doc) =>
				{
					setSettings(doc.data());
				});
			});
	}, [ setSettings ]);

	useEffect(() =>
	{
		fetchSettings();
		fetchRooms();
	}, [ fetchRooms, fetchSettings ]);

	const isLandscape = () => window.matchMedia('(orientation:landscape)').matches;
	const onWindowResize = useCallback(() =>
	{
		clearTimeout(window.resizeLag);
		window.resizeLag = setTimeout(() =>
		{
			delete window.resizeLag;
			if (isMobile)
			{
				setOrientation(isLandscape() ? 'landscape' : 'portrait');
			}
		}, 200);
	}, [ setOrientation, isMobile ]);

	useEffect(() =>
	{
		onWindowResize();
		window.removeEventListener('resize', onWindowResize);
		window.addEventListener('resize', onWindowResize);
	}, [ onWindowResize ]);

	useEffect(() =>
	{
		if (peersLength === 0 && room.info !== null)
		{
			roomClient.close();
		}
	// eslint-disable-next-line
	}, [ peersLength, room.info ]);

	return (
		<div
			className={(isMobile || useMobileView)?
				orientation === 'portrait' ? classes.rootM : classes.rootML
				: room.state==='connected' ?
					classes.rootConnected : classes.root
			}
			ref={guestHomeRef}
		>
			{ room.state === 'connected' &&

				<GuestMeetingView
					guestHomeRef={guestHomeRef}
				/>
			}

			{ (room.state === 'new' || room.state === 'connecting' || (room.state === 'closed' && room.info === null)) &&
			<GuestJoinView
				fetchRoomsComplete={fetchRoomsComplete}
			/>
			}

			{ (room.state === 'closed' && room.info !== null) &&
				<GuestHungUpView />
			}

		</div>
	);
};

GuestHome.propTypes =
{
	room           : PropTypes.object.isRequired,
	roomClient     : PropTypes.object.isRequired,
	peersLength    : PropTypes.number.isRequired,
	classes        : PropTypes.object.isRequired,
	setSettings    : PropTypes.func.isRequired,
	setRooms       : PropTypes.func.isRequired,
	isMobile       : PropTypes.bool.isRequired,
	useMobileView  : PropTypes.bool.isRequired,
	setOrientation : PropTypes.func.isRequired,
	resetRoom      : PropTypes.func.isRequired,
	orientation    : PropTypes.string
};

const mapStateToProps = (state) =>
{
	return {
		room          : state.room,
		peers         : state.peers,
		peersLength   : peersLengthSelector(state),
		loginEnabled  : state.me.loginEnabled,
		loggedIn      : state.me.loggedIn,
		locale        : state.intl.locale,
		localesList   : state.intl.list,
		settings      : state.me.settings,
		rooms         : state.me.rooms,
		isMobile      : state.me.browser.platform === 'mobile',
		useMobileView : state.me.useMobileView,
		orientation   : state.room.orientation ?
			state.room.orientation : state.me.useMobileOrientation
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setSettings : (settings) =>
		{
			dispatch(meActions.setSettings(settings));
		},
		setRooms : (rooms) =>
		{
			dispatch(meActions.setRooms(rooms));
		},
		setOrientation : (orientation) =>
		{
			dispatch(roomActions.setOrientation(orientation));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.room.orientation === next.room.orientation &&
				prev.settings.displayName === next.settings.displayName &&
				prev.settings === next.settings &&
				prev.settings.advancedMode === next.settings.advancedMode &&
				prev.me.displayNameInProgress === next.me.displayNameInProgress &&
				prev.me.loginEnabled === next.me.loginEnabled &&
				prev.me.loggedIn === next.me.loggedIn &&
				prev.me.picture === next.me.picture &&
				prev.intl.locale === next.intl.locale &&
				prev.intl.localesList === next.intl.localesList &&
				prev.peers === next.peers &&
				prev.me.rooms === next.me.rooms &&
				prev.me.settings === next.me.settings &&
				prev.me.useMobileView === next.me.useMobileView &&
				prev.me.useMobileOrientation === next.me.useMobileOrientation &&
				prev.room.state === next.room.state
			);
		}
	}
)(withStyles(styles)(GuestHome)));